var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{attrs:{"id":"check-email-message"}},[_vm._v("Please check your email for a validation link")])}
var staticRenderFns = []

export { render, staticRenderFns }